<div class="heading-wrap">
    <div class="headings">Provider Types  <i class="icons-image icon-info-light-gray" matTooltip="Select the provider category (Indian SI including Indian heritage players like Infosys, Wipro, etc. and Global SI includes players like Accenture, Capgemini, etc.)"></i></div>
</div>
<div class="section tour-provider">
    <button (click)="changeProvider(provider)" class="cbtn-primary" [ngClass]="{'cbtn-secondary': provider.isSelected, 'btn-primary': !provider.isSelected}" *ngFor="let provider of providers">
        {{provider.spt}}
    </button>
</div>